import {Component, OnInit} from '@angular/core';
import {UserDataService} from '../../user-data.service';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

    formResponse: boolean;
    formSent: boolean;
    customErrorMessage: string;
    customSuccessMessage: string;

    // Server Response After Send
    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    serverErrorMessages: string;
    pwdPattern = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_#?!@$%^&*-]).{7,}$'

    passwordUpperCase = false;
    passwordSpecial = false;
    passwordNumber = false;

    errorResp: string;

    constructor(private userDataService: UserDataService,
                private router: Router) {}
    userData: any = [];
    passwords: object;

    ngOnInit() {}

    onSubmit(form: NgForm) {
        this.passwords = {
            oldPassword: form.value.oldPassword,
            newPassword: form.value.newPassword,
        }

        if(form.valid) {
            this.userDataService.changePassword(this.passwords).subscribe(resData => {
                this.formResponse = true;
                this.formSent = true;
                this.customSuccessMessage = "Parola a fost schimbată cu succes.";

                this.redirectUser();

            }, error => {

                this.formResponse = false;
                this.formSent = true;

                this.errorResp = error.error.reason;
                if (this.errorResp === 'invalidOldPassword') {
                    this.customErrorMessage = "Parola veche nu este corecta!";
                } else if (this.errorResp === 'invalidNewPassword') {
                    this.customErrorMessage = "Parola noua nu este valida!";
                } else {
                    this.customErrorMessage = "Ceva nu a functionat corect. Te rugam sa mai incerci o data.";
                }
            });
        } else {
            this.formResponse = false;
            this.formSent = true;
        }


    }

    // Redirect user after a few seconds
    redirectUser() {
        setTimeout(() => {
            this.router.navigate(['/cont']);
        }, 4000);
    }
}
